import { useEffect, useState } from "react";

type Breakpoints = "xs" | "sm" | "md" | "lg" | "xl";

function getBreakpoint(): Breakpoints {
  const width = window.innerWidth;

  if (width <= 480) {
    return "xs";
  }
  else if (width > 480 && width <= 768) {
    return "sm";
  }
  else if (width > 768 && width < 1024) {
    return "md";
  }
  else if (width >= 1024 && width < 1280) {
    return "lg";
  }

  return "xl";
}

export const useBreakpoints = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoints>(getBreakpoint);

  useEffect(() => {
    const abortController = new AbortController();

    window.addEventListener("resize", () => setBreakpoint(getBreakpoint), {
      signal: abortController.signal,
    });

    return () => {
      abortController.abort();
    };
  }, []);

  return breakpoint;
};
